import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { CreateReport } from './components/CreateReport'
import { OperationsList } from './components/OperationsList'
import { LibraryPage } from './components/LibraryPage'
import { PreviewReportModal } from './components/PreviewReportModal'
import { VoyageList } from './components/VoyageList'
import InportConsumptionReport from './components/InportConsumptionReport'
import PositionReportsTabs from './components/PositionReportsTabs'
import DefectListPage from '../QHSE/components/DefectListPage'
import { ComingSoon } from '../common/ComingSoon'
import CargoPage from './CargoOperations/CargoPage'
import CiiSummary from './components/CiiSummary'
import { DPR_ROUTE_SEGMENT } from './core/routes'

// const operationsBreadCrumbs: Array<PageLink> = [
//     {
//         title: 'Operations',
//         path: '/operations',
//         isSeparator: false,
//         isActive: false,
//     },
//     {
//         title: '',
//         path: '',
//         isSeparator: true,
//         isActive: false,
//     },
// ]

import DailyPositionReport from './components/DailyPositionReport'
import OperationsDashboard from './components/OperationsDashboard'
import DailyMovementReportPage from './components/DailyMovementReportPage'

const OperationsPage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    index
                    element={<Navigate to='dashboard' replace />}
                />
                <Route
                    path='dashboard'
                    element={<OperationsDashboard />}
                />
                <Route
                    path='voyages'
                    element={<VoyageList />}
                />
                <Route path='overview' element={<PositionReportsTabs />} />

                <Route
                    path='create/:assignmentId'
                    element={<CreateReport />}
                />
                <Route
                    path='library'
                    element={<LibraryPage />}
                />
                <Route
                    path='report-preview'
                    element={<PreviewReportModal />}
                />
            </Route>

             <Route
                    path='inport-consumption'              
                    element={<InportConsumptionReport />}
                />
                <Route
                    path='defects-list'
                    element={<DefectListPage />}
                />
                {/* 🔹 NEW: Coming Soon routes */}
      <Route
        path='offshore-report'
        element={<ComingSoon title='Off Shore Report' />}
      />
      <Route
        path='form-index'
        element={<ComingSoon title='Form Index' />}
      />
      <Route
        path='reports/kpis'
        element={<ComingSoon title='KPIs' />}
      />
      <Route
        path='reports/voyage-abstract'
        element={<ComingSoon title='Voyage Abstract' />}
      />
      <Route
        path='reports/cii-summary'
        element={<CiiSummary />}
      />
      <Route
        path='reports/cargo-plan-log'
        element={<ComingSoon title='Cargo Plan/Log' />}
      />
      <Route
        path={DPR_ROUTE_SEGMENT}
        element={<DailyPositionReport />}
      />
      <Route
        path='cargo-operations'
        element={<CargoPage />}
      />
      <Route
        path='coastal-position-report'
        element={<DailyMovementReportPage />}
      />
    
        </Routes>
    )
}

export default OperationsPage
